<template>
    <div class="ur-date-picker ur-date-picker-single ur-input" :class="'ur-date-picker--'+$_size">
        <div class="ur-date-picker-wrapper" :class="wrapperClass">
            <ur-text-field ref="from-text" class="ur-date-picker__text-field"
                            v-model="selectedWeek.textInput"
                            :mask="inputType.replace(/#/g,'%#').replace(/[Yw]/g,'#')"
                            :placeholder="noPlaceholder?'':inputType"
                            :disabled="disabled"
                            :no-shake="noShake"
                            @focus="onFocus(1, $event)"
                            @enter="onUpdate()"
                            @keyup.ctrl.86="onUpdate()"
                            @keydown.tab="(e)=>onUpdate(e)"/><!--
         --><ur-icon-wrapper class="ur-date-picker__icon-wrapper" :class="iconWrapperClass" @click.native="onClickIcon(1, $event)">
                <ur-icon class="ur-date-picker__icon" icon="calendar"></ur-icon>
            </ur-icon-wrapper>
            <div v-if="messageShow" :style="$_messageStyle()"
                class="ur-date-picker__message ur-validator__message"
                :class="messageClass">{{messageShow}}</div>
        </div>
        <div class="ur-date-picker__calendar" ref="floating" v-ur-attach-root="'anchor'" v-click-outside.anchor="onClickOutside">
            <div class="ur-date-picker__calendar__month-area">
                <ur-icon-wrapper @click.native.stop="onClickPrev()">
                    <ur-icon icon="expand_menu" ></ur-icon>
                </ur-icon-wrapper>
                <div>
                    <span>
                        {{getMM(calendarMonth)}}
                    </span>
                    <span>
                        {{getYY(calendarMonth)}}
                    </span>
                </div>
                <ur-icon-wrapper @click.native.stop="onClickNext()">
                    <ur-icon icon="collapse_menu" ></ur-icon>
                </ur-icon-wrapper>
            </div>
            <div class="ur-date-picker__calendar__range-container">
                <div class="ur-date-picker__calendar__date-area">
                    <div class="ur-date-picker__calendar__day ur-date-picker__calendar__week__row">
                        <div class="ur-date-picker__calendar__week__row-background"></div>
                        <div class="ur-date-picker__calendar__week__row-content">
                            <span class="ur-date-picker__calendar__week__row-content-weeknum"></span>
                            <template v-for="(day, idx) in weekDay">
                                <span :key="idx" :class="weekDayClass(idx)">{{day.text}}</span>
                            </template>
                        </div>

                    </div>
                    <div class="ur-date-picker__calendar__date-wrapper" @mouseleave="hoverWeek=''">
                        <template v-for="(week,wIdx) in monthCalendar(calendarMonth,1)">
                            <div :key="wIdx" class="ur-date-picker__calendar__week ur-date-picker__calendar__week__row">
                                <div :class="weekClass(calendarMonth[0], week[0].value)"
                                     @mouseenter="setHover(calendarMonth[0], week[0].value)"
                                     @click.stop="onClickWeek(calendarMonth[0],week[0].value)">
                                    <span :class="weekStyle(calendarMonth[0], week[0].value)">w{{getWeekNumber(calendarMonth[0],week[0].value)}}</span>
                                    <template v-for="(date,dIdx) in week">
                                        <span :key="dIdx" :class="dateClass(date,dIdx)">{{date.text}}</span>
                                    </template>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <ur-action-bar  class="ur-date-picker__action-bar">
                <ur-button v-if="!autoConfirm" tabindex="-1" sm main @click.native.stop="onConfirm">{{confirmLabel}}</ur-button>
            </ur-action-bar>
        </div>
    </div>
</template>

<script>
    import urValidatorMixin from '../../../mixins/urValidator/urValidatorMixin.vue';
    const DUMMY_EVENT = {
        preventDefault: ()=>{}
    };
    //ur-week-picker는 주를 선택하기 위한 컴포넌트 입니다.
    //#ur-week-picker is used to select week number.
    export default {
    // TODO: validator를 넣어놓긴했는데 message띄우는 영역 설정을 안했네요.. ur-radio-wrapper등을 참고하여 메시지를 넣고 css설정을 해주시면 되겠습니다.
    // rules를 통합으로 넣을지 fromRules, toRules, rules 세가지를 사용하고 fromValidate->toValidate->validate 순서로 validate를 할지 고민하다가 결론을 못내고 미루다가 깜빡했나봐요
    // TODO: dropdown, datepicker 같이 클릭했을 때 위로 뜨는 창이 생기는 경우 ur-tooltip 혹은 v-ur-tooltip처럼 wrapper의 overflow설정에 영향을 안받으면서 뜰 수 있도록 설정을...
    // 1~2월중에 하려고는 했었는데 미루다가 못했습니다 ㅠ
    name: 'ur-week-picker',
    mixins: [urValidatorMixin],
    inject: {
        urInput: {from:'urInput', default: () => undefined}
    },
    props: {
        // $ver: v0.2.1
        // $v-model
        // 선택된 year, week number를 나타내는 값입니다.
        // 해당 타입의 값을 element로 하는 length 2의 Array형태로 반환됩니다.
        // 형식에 맞지 않는 데이터가 입력될 경우 빈값(['',''])으로 변경될 수 있습니다.
        // #A value representing the year and week number.
        // #it is returned as an Array of length 2 whose value is the element.
        // $tags IDE, value
        value: {
            type: Array,
            default: () => {return ['','']}
        },
        // $ver: v2.1.2
        // 기간 선택시 자동 입력 여부입니다. true 일 경우 달력에서 기간 선택 완료시 confirm 을 누르지 않아도 자동으로 입력됩니다.
        // #Whether to enter automatically when selecting a period. If true, it is automatically entered when the period is selected in the calendar without pressing confirm.
        // $default: false
        autoConfirm: {
          type:Boolean,
          default: false
        },
        // $ver: v0.2.0
        // text-field영역에 입력되는 week-format입니다.
        // #The week-format entered in the text-field area.
        // $hide
        inputType: {
            type: String,
            default: 'YYYY-Www',

        },
        // $ver: v0.1.2
        // v-model로 반환될 date-format입니다.
        // 'date'(javascript Date object) 혹은 input-type과 동일하게 YY,YYYY,MM,DD와 특수문자등을
        // 포함한 문자열로 설정할 수 있습니다.
        // #Like 'date' (javascript Date object) or input-type,
        // #it can be set to a string including YY, YYYY, MM, DD and special characters.
        // $hide
        modelType: {
            type: String,
            default: 'YYYY-MM-DD',
            validator: (val) => {
                if(/^(date|array)$/i.test(val)) {return true;}
                return /^(?=.*yy)(?=.*mm)(?=.*dd)(yy|mm|dd|\W)+$/i.test(val)
                    && val.match(/y{1,4}/gi).length === 1
                    && val.match(/m{1,2}/gi).length === 1
                    && val.match(/d{1,2}/gi).length === 1;
            }
        },
        // $ver: v0.1.2
        // YYYY-MM-DD의 형식으로 선택가능한 minimum date를 설정할 수 있습니다.
        // #You can set a selectable minimum date in the format YYYY-MM-DD.
        // $hide
        minDate: {
            type: String,
            default: '1970-01-01',
            validator: (val) => {
                return /^(19[7-9][0-9]|[2-9][0-9]{3})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/.test(val);
            }
        },
        // $ver: v0.1.2
        // YYYY-MM-DD의 형식으로 선택가능한 maximum date를 설정할 수 있습니다.
        // #You can set a selectable maximum date in the format YYYY-MM-DD.
        // $hide
        maxDate: {
            type: String,
            default: '9999-12-31',
            validator: (val) => {
                return /^(19[7-9][0-9]|[2-9][0-9]{3})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/.test(val);
            }
        },
        // $ver: v0.1.2
        // text-field영역의 placeholder는 기본적으로 input-type이 형식에 따라 적절한 placeholder를 갖지만
        // no-placeholder 옵션을 통해 placeholder를 표시하지 않을 수 있습니다.
        // #Placeholders in the text-field area have an appropriate placeholder by default,
        // #although the input-type has a proper placeholder, but the no-placeholder option may not display the placeholder.
        // $default: false
        noPlaceholder: {
            type: Boolean,
            default: false
        },

        // $ver: v0.2.0
        // 크기 입니다. 'medium','small' 두 가지 중 하나를 입력해야 합니다.
        // #The size You must enter one of two types: medium or small.
        // $default: medium
        // $tags IDE, size
        size: {
            validator: function (value) {
                // The value must match one of these strings
                return ['medium', 'small'].indexOf(value) !== -1
            },
            // type: String,
            //default: 'medium'
        },

        // $ver: v0.1.2
        // medium 크기의 date-picker를 사용합니다. calendar의 크기는 변하지 않습니다.
        // #Use a medium size date-picker. The size of the calendar does not change.
        // $default: false
        medium: {
            type: Boolean,
            default: false
        },
        // $ver: v0.1.2
        // $abbr: medium
        md: {type: Boolean},
        // $ver: v0.1.2
        // small 크기의 date-picker를 사용합니다. calendar의 크기는 변하지 않습니다.
        // #Use a small size date-picker. The size of the calendar does not change.
        // $default: false
        small: {
            type: Boolean,
            default: false
        },
        // $ver: v0.1.2
        // $abbr: small
        sm: {type: Boolean},

        // $ver: v0.1.2
        // calendar영역의 confirm button에 들어갈 text를 설정할 수 있습니다. 다국어 처리를 위해 만들었습니다.
        // #You can set the text for the confirm button in the calendar area. Created for multilingual processing.
        confirmLabel: {
            type: String,
            default: 'Confirm'
        },
        // $ver: v0.2.x
        // 안내메시지 표현 형태 속성입니다. 'heavy', 'light' 속성을 지정할 수 있습니다.
        // #Announcement appearance attributes. You can specify the 'heavy' and 'light' attributes.
        messageStyle: {
            type: String,
            validator: function(value) {
                return ['heavy', 'light'].indexOf(value) !== -1;
            },
            default: 'heavy'
        },
        // $ver: v0.1.x
        // 미완성
        // $hide
        guideMessage: {type:String, default: undefined},
        // $ver: v0.1.x
        // 미완성
        // $hide
        successMessage: {type:String, default: undefined},

        /* [FROM VALIDATOR] */
        // rules
        // disabled
        // lazy
        // noShake
        /********************/
    },
    data() {return {
        default: {
            size: 'medium'
        },
        weekDay: [
            {text:'S', value: 'SUN'},
            {text:'M', value: 'MON'},
            {text:'T', value: 'TUE'},
            {text:'W', value: 'WED'},
            {text:'T', value: 'THU'},
            {text:'F', value: 'FRI'},
            {text:'S', value: 'SAT'}
        ],
        monthAbbr: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],

        today: '', // YYYY-MM-DD
        currTime: {}, // Date object

        // if user changes textInput, set selected same as textInput.(= onUpdate) and then $emit to v-model from selected (onConfirm)
        // if user changes selected, set textInput same as selected.(= onClickWeek) and then $emit to v-model from selected (onConfirm)
        selectedWeek: {
            year: '',   // YYYY
            week: '',   // week
            date: '',   // week start date YY-MM-DD
            value : '', // YYYY-Www, calendar selected value.
            textInput: '', // text-field value, depends on inputType
        } ,
        hoverWeek: '', // YYYY-MM-DD
        calendarMonth: [], // [YYYY, MM]
        showFlag: 0, // 0: none, 1: single calendar, 2: double calendar

        presetName: '',
        presetVal: '', // YYYY-MM-DD or [YYYY-MM-DD, YYYY-MM-DD]

        /* [FROM VALIDATOR] */
        // hasError
        // errorMessage
        // showValid
        // shake
        /********************/
        validateFlag:false,

        viewMode: 'daily' // daily, year, decade, quarter
    }},
    mounted(){
      window.addEventListener('resize', this.resize);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.resize);
    },
    computed: {
        /* [FROM VALIDATOR] */
        // isValidatable
        // el
        validateTarget() {return this.value;}, // validation setting
        /********************/

        $_size() {
            if((this.size && this.small) || (this.size && this.medium)){
                console.warn("Props related size are duplicated.")
            }
            switch(this.size){
                case 'small':   return 'small';
                case 'medium' : return 'medium';
            }

            if(this.medium || this.md) {return 'medium'}
            if(this.small || this.sm) {return 'small'}
            if(this.urInput) {return this.urInput.size}
            return this.default.size;
        },
        sundayIdx() {
            for(let idx in this.weekDay) {
                if(this.weekDay[idx].value ==='SUN') {
                    return parseInt(idx);
                }
            }
            return -1;
        },
        saturdayIdx() {
            for(let idx in this.weekDay) {
                if(this.weekDay[idx].value ==='SAT') {
                    return parseInt(idx);
                }
            }
            return -1;
        },
        // for validatorMixin
        messageShow() {
            if(this.hasError === undefined) {
                return this.guideMessage;
            }
            if(this.hasError === true) {
                return this.errorMessage;
            }
            if(this.hasError === false) {
                return this.successMessage || this.guideMessage;
            }
            return undefined;
        },
        wrapperClass() { return {
            'ur-validator--error': this.hasError === true,
            'ur-validator--valid': this.showValid && this.hasError === false,
            'ur-validator--shake': this.shake
        }},
        messageClass() {
            return ['ur-date-picker__message--'+this.messageStyle];
        },
        iconWrapperClass() {
            return {
                'ur-date-picker__icon-wrapper-disabled' : this.disabled,
            }
        }
    },
    watch: {
        // for validatorMixin
        successMessage: {
            immediate: true,
            handler(val) {
                this.showValid = !!val;
            }
        },
        'selectedWeek.value'(val){
            this.selectedWeek.textInput = val;

            if(val === ''){
                this.setSelectedWeek('', '');
                this.setCalendarMonth(this.calendarMonth);
                return ;
            }
            let tmp = val.split('-W');
            let y = parseInt(tmp[0]);
            let weekNum = parseInt(tmp[1]);
            let startYmd = this.getDateFromWeekNum(y,weekNum);
            this.setSelectedWeek(y, startYmd);
            let mm = parseInt(this.selectedWeek.date.split('-')[1]);
            this.calendarMonth[0] = y;
            this.calendarMonth[1] = mm;

            this.setCalendarMonth(this.calendarMonth);
        },

        value: {
            immediate: true,
            handler(val){
                let tmp ;
                if(val === null || val[0] ==='' || val[1] ==='') {
                    //값 없으면 오늘 날짜 기준 달력 세팅
                    tmp = this.today < this.minDate? this.minDate : this.today > this.maxDate? this.maxDate : this.today;
                    tmp = tmp.split('-');
                    this.calendarMonth[0] = parseInt(tmp[0]);
                    this.calendarMonth[1] = parseInt(tmp[1]);
                }else{
                    let year = parseInt(val[0]);
                    let week = parseInt(val[1]);

                    let startYmd = this.getDateFromWeekNum(year, week);
                    this.setSelectedWeek(year, startYmd);
                    let ww = (week < 10)? '0'+week : week;
                    this.selectedWeek.value = year+ '-W'+ ww;
                    let mm = parseInt(this.selectedWeek.date.split('-')[1]);
                    this.calendarMonth[0] = year;
                    this.calendarMonth[1] = mm;
                }
                this.setCalendarMonth(this.calendarMonth);

                if(this.validateFlag) {this.validateFlag=false;this.validateOnEvent();}
            }
        },
        showFlag(newFlag,oldFlag) {
            let tmp;
            // 1. Open & Close
            if(newFlag){this.$refs.floating.open(); this.$emit('toggle-floating', true);}
            else       {this.$refs.floating.close(); this.$emit('toggle-floating', false);}
            // 2. Calculation something
            if(newFlag === 1) {
                if(this.selectedWeek.value !== '') {
                    let mm = this.selectedWeek.date.split('-')[1];
                    tmp = [this.selectedWeek.year, mm];
                } else {
                    tmp = this.today < this.minDate? this.minDate : this.today > this.maxDate? this.maxDate : this.today;
                    tmp = tmp.split('-');
                }

                this.setCalendarMonth([parseInt(tmp[0]),parseInt(tmp[1])]);
            }
        }
    },
    created() {
        this.currTime = new Date();
        this.today = this.dateToYmd(this.currTime);
        if(!Array.isArray(this.calendarMonth) || this.calendarMonth.length !==2 || this.isEqualArray(['',''],this.calendarMonth)) {
            let date = this.today < this.minDate? this.minDate : this.today > this.maxDate? this.maxDate : this.today;
            let tmp = this.dateToYmd(this.ymdToDate(date,0,0,0));
            tmp = tmp.split('-');
            this.setCalendarMonth([parseInt(tmp[0]),parseInt(tmp[1])]);
        }
    },
    methods: {
        /* [FROM VALIDATOR] */
        // validate()        --+
        // isValid()         --+-- exposed methods for manual validate control
        // clearValidation() --+
        // validateOnEvent() -> should be set by each component which uses urValidatorMixin
        /********************/

        toValidYmd(ymd) {
            if(!ymd || typeof ymd !== 'string') {return '';}
            if(ymd > this.maxDate) {ymd = this.maxDate;}
            if(ymd < this.minDate) {ymd = this.minDate;}
            return ymd;
        },
        $_parseInt(val) {
            let tmp = parseInt(val);
            if(Number.isNaN(tmp)) {return undefined;}
            return tmp;
        },
        setCalendarMonth(calendarMonth) {
            let YYYY,MM;
            if(Array.isArray(calendarMonth) && calendarMonth.length ===2) {
                this.calendarMonth = [];
                YYYY = parseInt(calendarMonth[0]);
                MM = parseInt(calendarMonth[1]);
                if(MM < 1) {
                    YYYY -= 1;
                    MM += 12;
                }
                if(MM > 12) {
                    YYYY += 1;
                    MM -= 12;
                }
                this.calendarMonth.push(YYYY);
                this.calendarMonth.push(MM);
            }
        },
        isEqualArray(arr1,arr2) {
            if(!(Array.isArray(arr1) && Array.isArray(arr2))) {return false;}
            if(arr1.length !== arr2.length){return false;}
            for(let i = 0 ; i < arr1.length ; i++) {
                if(!this.isEqualModel(arr1[i],arr2[i])) {return false;}
            }
            return true;
        },
        isEqualModel(m1, m2) {
            if(m1 instanceof Date && m2 instanceof Date) {
                if(m1.getFullYear() === m2.getFullYear() && m1.getMonth() === m2.getMonth() && m1.getDate() === m2.getDate() ) {
                    return true;
                }
            }
            if(Array.isArray(m1) && Array.isArray(m2)) {return this.isEqualArray(m1,m2);}
            return m1 === m2;
        },

        /*
        ~  CONVERTERS
        ~  'ymd': fixed format that used on default date format in this component 'YYYY-MM-DD'
        ~  'input': string used in text-field. only have Numbers.
        ~  'model': Date or Array or some formatted string which is set as props.modelType.
        ~           It is used as type of v-model in single date-picker.
        ~
        ~  ymdToText(ymd, textFormat)
        ~  ymdToModel(ymd)
        ~  dateToYmd(date)
        ~  ymdToDate(ymd, dy, dm, dd): dy, dm, dd is difference of year, month, date. default is 0.
        ~                              eg.) ymdToDate('1991-02-04', 1, -1, 3) => new Date(1992, 0, 7) [*2nd arg 0 is Jan.]
        */

        // @vuese
        // $ver: v0.1.2
        // $arg: target data to convert
        // $arg: target data's format string (eg. YYYY-MM-DD)
        // $arg: return data's format string (eg. DD/MM/YYYY)
        // $return: converted data
        // <em>arg1</em>의 format을 가진 <em>arg0</em>값을 <em>arg2</em>의 format에 맞게 변환하여 반환합니다.
        // #Converts <em>arg0</em> with the format of <em>arg1</em> to match the format of <em>arg2</em> and returns.

        ymdToText(val, textFormat) {
            let tmp, rtn;
            // valid val?
            if(!val || typeof(val) !== 'string') {return '';}
            tmp = val.split('-');
            if(tmp.length !== 3) {return '';}
            // valid textFormat?
            if(!/^(?=.*yy)(?=.*mm)(?=.*dd)(yy|mm|dd|\W)+$/i.test(textFormat)
                || textFormat.match(/y{1,4}/gi).length !== 1
                || textFormat.match(/m{1,2}/gi).length !== 1
                || textFormat.match(/d{1,2}/gi).length !== 1) {
                console.error('[UR-DATE-PICKER] invalid text format is given: '+textFormat);
                return '';
            }
            rtn = textFormat.toUpperCase();
            rtn = rtn.replace('YYYY',tmp[0]);
            rtn = rtn.replace('YY', tmp[0].slice(2));
            rtn = rtn.replace('MM', tmp[1]);
            rtn = rtn.replace('DD', tmp[2]);
            return rtn;
        },
        // @vuese
        // $ver: v0.1.2
        // $arg: target data to convert (format is YYYY-MM-DD)
        // $return: converted data
        // 입력값을 <em>ur-date-picker</em>에 설정된 model-type에 맞게 변환합니다.
        // 입력값은 YYYY-MM-DD의 format으로 주어져야 합니다.
        // #Convert the input to match the model-type set in the <em>ur-date-picker</em>.
        // #Input must be given in the format of YYYY-MM-DD.
        /*NOSONAR*/ymdToModel(val) {
            // from YYYY-MM-DD to v-model value
            let tmp, rtn;
            if(!val || typeof(val) !== 'string') {return '';}
            tmp = val.split('-');
            if(tmp.length !== 3) {return '';}
            if(/^date$/i.test(this.modelType)) {
                return new Date(parseInt(tmp[0]), parseInt(tmp[1])-1);
            }
            if(/^array$/i.test(this.modelType)) {
                return val.split('-');
            }
            return this.ymdToText(val, this.modelType);
        },
        // @vuese
        // $ver: v0.1.2
        // $arg: target data to convert (javascript Date object)
        // $return: converted data (YYYY-MM-DD)
        // javascript Date object를 입력값으로 주면 YYYY-MM-DD 형식의 문자열로 변환하여 반환합니다.
        // #If a javascript Date object is given as input, it is converted to a string in YYYY-MM-DD format and returned.
        dateToYmd(date) {
            if(!(date instanceof Date)) {return '';}
            let YYYY = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? '0'+MM:MM;
            let DD = date.getDate();
            DD = DD < 10 ? '0'+DD:DD;
            return [YYYY,MM,DD].join('-');
        },
        ymdToDate(ymd,dy=0,dm=0,dd=0) {
            let tmp = ymd.split('-');
            return new Date(parseInt(tmp[0]) + dy,parseInt(tmp[1]) - 1 + dm,parseInt(tmp[2]) + dd);
        },
        onFocus(idx, ev) {
            this.showFlag = idx;
        },
        onClickIcon(idx, ev) {
            if(this.disabled) {
                return;
            }
            if(this.showFlag === 1) {
                this.onClickOutside();
                return;
            }
            this.showFlag = this.showFlag === idx ? 0 : idx;
        },
        inputToYw(input){
            if(!input || typeof(input) !== 'string') {return '';}
            let y,w;
            input = input.replace(/[-]/g,'').replace(/[W]/g,'');
            if(input.length === 6) {
                y = parseInt(input.slice(0,4));
                if(y < 1970) {return '';}
                w = parseInt(input.slice(4,6));
                if(w > 53 ) {return '';}
            }else{
                return '';
            }
            let ww = (w < 10)? '0'+w : w;
            return String(y)+String(ww);
        },
        onUpdate(tabEvent = DUMMY_EVENT) {
            if(tabEvent.shiftKey) {this.showFlag=0;return;}
            // textInput is updated
            let textInput, newValue;

            // single date picker
            textInput = this.selectedWeek.textInput;
            //check Input Value
            newValue = this.inputToYw(textInput);
            if(newValue !== '') {
                // proper input received
                let formattedValue = newValue.slice(0,4) +'-W'+newValue.slice(4,6);
                if(formattedValue !== this.selectedWeek.value) {
                    // change selected date same as input
                    this.selectedWeek.textInput = formattedValue;
                    this.selectedWeek.value = formattedValue;
                    tabEvent.preventDefault();return;
                }
                // if selected date is already set, update v-model & close calendar
                this.onConfirm();return; // not execute e.preventDefault
            } else if(this.selectedWeek.value !== ''){
                // empty input
                this.selectedWeek.textInput = '';
                this.selectedWeek.value = '';
                tabEvent.preventDefault();return;
            } else {
                this.selectedWeek.textInput = '';
                this.selectedWeek.value = '';
                if(textInput !== ''){
                    tabEvent.preventDefault();return;
                }
            }
            // already clear, update v-model & close calendar
            this.onConfirm();return; // not execute e.preventDefault

        },
        onClickWeek(y, startYmd){
            this.setSelectedWeek(y, startYmd);
            let ww = (this.selectedWeek.week < 10)? '0'+this.selectedWeek.week : this.selectedWeek.week;
            this.selectedWeek.value = y + '-W'+ ww;
            if(this.autoConfirm){
                setTimeout(() => {
                    this.onConfirm();
                })
            }
        },
        setSelectedWeek (y, startYmd) {
            this.selectedWeek.year = y;
            if(startYmd === ''){
                this.selectedWeek.week = '';
                this.selectedWeek.date = '';
            }else{
                this.selectedWeek.week = String(this.getWeekNumber(y, startYmd));
                this.selectedWeek.date = startYmd;
            }
        },
        getDateFromWeekNum(y,wNum){
            let d = (1 + (wNum - 1) * 7); // 1st of January + 7 days for each week
            return this.dateToYmd(new Date(y, 0, d));
        },
        onConfirm(e) {
            // selected confirmed and want to be update v-model & actual date
            // close calendar
            if(!((parseInt(this.value[0]) === this.selectedWeek.year)
                    && parseInt(this.value[1]) === this.selectedWeek.week)) {

                this.$emit('input',[String(this.selectedWeek.year),String(this.selectedWeek.week)]);
                // $ver: v0.2.1
                // $arg: updated value
                // 확인 버튼을 눌렀을때, 선택된 값을 파라미터로 이벤트를 발생시킵니다.
                // #When you are click confirm button, an event is triggered with the changed value(YYYY-Www) as a parameter.
                this.$emit('confirmed', this.selectedWeek.value)
                this.validateFlag=true;
            } else {
                this.validateOnEvent();
            }

            this.showFlag = 0;
        },
        onClickPrev() {
            let yyyy = parseInt(this.calendarMonth[0]);
            let mm = parseInt(this.calendarMonth[1]);
            this.setCalendarMonth([yyyy, mm - 1]);
        },
        onClickNext() {
            let yyyy = parseInt(this.calendarMonth[0]);
            let mm = parseInt(this.calendarMonth[1]);
            this.setCalendarMonth([yyyy, mm + 1]);
        },
        onClickOutside(e) {
            // set selected back to original value
            // close calendar
            if(this.value === null || this.value[0] === '' ||  this.value[1] === ''){
                this.selectedWeek.value = '';
            }else{
               let startYmd = this.getDateFromWeekNum(this.value[0], this.value[1]);
               this.setSelectedWeek(this.value[0], startYmd);
               let ww = (parseInt(this.value[1]) < 10)? '0'+ this.value[1]: this.value[1];
               this.selectedWeek.value = this.value[0] + '-W'+ ww;
            }
            this.showFlag=0;
        },
        getMM(month){
            let m = parseInt(month[1])-2+1;
            if(m < 0 ) {
                m = m + 12;
            } else if (m>11) {
                m = m - 12;
            }
            m = m < 0 ? m+12 : m > 11 ? m-12 : m;
            return this.monthAbbr[m];
        },
        getYY(month){
            let m = parseInt(month[1])-2+1;
            let y = parseInt(month[0]);
            if(m < 0 ) {
                y = y - 1;
            } else if (m>11) {
                y = y + 1;
            }
            return y;
        },
        getWeekNumber(y,ymd){
            let day = new Date(ymd);
            let calendarY= parseInt(y);
            let firstDayOfYear = new Date(calendarY, 0, 1);
            const pastDaysOfYear = (day - firstDayOfYear) / 86400000;
            return Math.ceil((pastDaysOfYear + firstDayOfYear.getDay() + 1) / 7);
        },
        makePrevDate(calendarMonth, flag) {
            let arr = [];
            // prev month's last few days
            let selMon = new Date(calendarMonth[0],calendarMonth[1]-2+flag);
            let idx = selMon.getDay();
            for(let i = 1 - idx;i < 1;i++) {
                let tmp = new Date(calendarMonth[0],calendarMonth[1]-2+flag,i);
                let value = this.dateToYmd(tmp);
                let state = 'prev';
                if(value < this.minDate) {state = 'disabled';}
                if(this.maxDate < value) {state = 'disabled';}

                arr.push({
                    text: tmp.getDate(),
                    value: value,
                    state: state,
                });
            }
            return [arr, idx];
        },
        makeCurrDate(calendarMonth, flag, arr, idx) {
            let rtn = [] ;
            // curr month's full days
            let tmp = this.dateToYmd(new Date(calendarMonth[0],calendarMonth[1]-2+flag)).slice(0,8);
            let maxDate = (new Date(calendarMonth[0],calendarMonth[1]-1+flag) - new Date(calendarMonth[0],calendarMonth[1]-2+flag)) / 24 / 60 / 60 / 1000;
            for(let i = 1; i <= maxDate; i++) {
                let value = tmp + (i<10?'0'+i:i);
                let state = false;
                if(value < this.minDate) {state = 'disabled';}
                if(this.maxDate < value) {state = 'disabled';}

                arr.push({
                    text: i,
                    value: value,
                    state: state,
                });
                if(idx === 6) {
                    idx = 0;
                    rtn.push(arr);
                    arr = [];
                } else {
                    idx++;
                }
            }
            return [rtn, arr, idx];
        },
        makeNextDate(calendarMonth, flag, rtn, arr, idx) {
            // next month's first few days
            for(let i = idx; i<=6; i++) {
                let tmp = new Date(calendarMonth[0],calendarMonth[1]-1+flag,i-idx+1);
                let value = this.dateToYmd(tmp);
                let state = 'next';
                if(value < this.minDate) {state = 'disabled';}
                if(this.maxDate < value) {state = 'disabled';}

                arr.push({
                    text: tmp.getDate(),
                    value: value,
                    state: state,
                });
            }
            rtn.push(arr);
            return rtn;
        },
        monthCalendar(calendarMonth,flag) {
            let rtn = [], arr = [], tmp;
            let idx;

            tmp = this.makePrevDate(calendarMonth, flag);
            idx = tmp[1];
            arr = tmp[0];

            tmp = this.makeCurrDate(calendarMonth, flag, arr, idx);
            rtn = tmp[0];
            arr = tmp[1];
            idx = tmp[2];
            if(idx === 0 ){
                return rtn;
            }
            rtn = this.makeNextDate(calendarMonth, flag, rtn, arr, idx);
            return rtn;
        },
        weekClass(y, ymd){
            let rtn = [];
            let thisWeekNum = this.getWeekNumber(y, ymd);
            rtn.push('ur-date-picker__calendar__week__row-content');
            rtn.push('ur-date-picker__calendar__week');
            if(thisWeekNum === this.hoverWeek) rtn.push('ur-date-picker__calendar__week--hover');
            if(thisWeekNum === parseInt(this.selectedWeek.week)) rtn.push('ur-date-picker__calendar__week--selected');
            return rtn;
        },
        weekStyle(y, ymd){
            let rtn = [];
            rtn.push('ur-date-picker__calendar__week__row-content-weeknum');
            let thisWeekNum = this.getWeekNumber(y,ymd);
            if(thisWeekNum === parseInt(this.selectedWeek.week)) rtn.push('ur-date-picker__calendar__week__row-content-weeknum--selected');
            return rtn;
        },
        setHover(y, ymd){
            this.hoverWeek=this.getWeekNumber(y,ymd);
        },
        dateClass(date, dIdx) {
            let rtn = ['ur-date-picker__calendar__weekdate'];
            if(date.state === 'disabled') rtn.push('ur-date-picker__calendar__week--disabled');
            if(date.state === 'invisible') rtn.push('ur-date-picker__calendar__week--invisible');
            else if(date.state) rtn.push('ur-date-picker__calendar__week--other-month');
            rtn.push(this.weekDayClass(dIdx));
            return rtn;
        },
        weekDayClass(idx) {
            if(idx === this.sundayIdx) return 'ur-date-picker__calendar__date--sunday';
            if(idx === this.saturdayIdx) return 'ur-date-picker__calendar__date--saturday';
            return '';
        },
        weekToFromTo(arr) {
            if(!arr || Array.isArray(arr) || arr.length < 2) {return null}
            var y = arr[0], w = arr[1];
            var dt = new Date(y,0,(w-1)*7+1);
            var st = new Date(dt.setDate(dt.getDate()-dt.getDay()))
            var ed = new Date(dt.setDate(dt.getDate()-dt.getDay()+6))
            return [st,ed];
            
        },
        resize(e){
            if(this.$refs.floating.isShow() === true){
              this.$refs.floating.resize(e);
            }
        },
    },
    provide() {
        let rtn = {};
        let odf = Object.defineProperty;
        let urInput = {};
        odf(urInput, 'size', {get: ()=>this.$_size});
        rtn['urInput'] = urInput;
        return rtn;
    },
    directives:  {
        'picker-click-outside': {
            inserted(el,binding, vnode) {
                const handler = (e) => {
                    if (!(el.contains(e.target) || el === e.target)) {
                        binding.value(e)
                    }
                };
                el.__vueClickOutside__ = handler;
                document.body.addEventListener('click', el.__vueClickOutside__);
            },
            unbind(el,binding,vnode) {
                document.body.removeEventListener('click', el.__vueClickOutside__);
                delete el.__vueClickOutside__;
            }
        }
    }
}
</script>
